import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import ConfereAIAdminLayout from '../components/Products/ConfereAI/pages/ConfereAIAdminLayout';
import themeConfereAI from '../components/Products/ConfereAI/themeConfereAI';
import Dashboard from '../components/Products/ConfereAI/pages/Dashboard';
import Insumos from '../components/Products/ConfereAI/pages/Insumos';
import Receitas from '../components/Products/ConfereAI/pages/Receitas';
import Fornecedores from '../components/Products/ConfereAI/pages/Fornecedores';
import Entradas from '../components/Products/ConfereAI/pages/Entradas';
import Inventario from '../components/Products/ConfereAI/pages/Inventario';
import ListaDeCompras from '../components/Products/ConfereAI/pages/ListaDeCompras';

const ConfereAIRoutes = () => (
  <ThemeProvider theme={themeConfereAI}>
    <Routes>
      <Route element={<ConfereAIAdminLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/insumos" element={<Insumos />} />
        <Route path="/receitas" element={<Receitas />} />
        <Route path="/fornecedores" element={<Fornecedores />} />
        <Route path="/entradas" element={<Entradas />} />
        <Route path="/inventario" element={<Inventario />} />
        <Route path="/lista-compras" element={<ListaDeCompras />} />
      </Route>
    </Routes>
  </ThemeProvider>
);

export default ConfereAIRoutes;

